<mic-breadcrumb id="product-import-breadcrumb">
  <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
  <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
  <mic-breadcrumb-link label="{{ translationService.translate('productImportText') }}"></mic-breadcrumb-link>
</mic-breadcrumb>

<h3 class="m-0 mt-3" id="product-import-heading">{{ translationService.translate('productImportText') }}</h3>

<div class="mt-5">
  <mic-status class="primary import-status" style="display: flex; align-items: center">
    <mic-icon class="sm" icon="info"></mic-icon>
    Please drop the files in the Azure file storage and then select the Import Product Data button below
  </mic-status>
</div>

<button
  class="mt-6 import-button"
  id="add-button"
  type="button"
  mat-flat-button
  color="primary"
  [disabled]="isImporting"
  (click)="importProducts()"
>
  @if (isImporting) {
  <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px"></mat-spinner>
  } @if (!isImporting) {
  <mat-icon>upload_2</mat-icon>
  }
  {{ isImporting ? translationService.translate('importingText') : translationService.translate('importProductDataText') }}
</button>

<mat-form-field appearance="outline" class="w-full mt-6" id="importResult" subscriptSizing="dynamic">
  <mat-label class="custom-label-error">
    <mat-icon style="margin-right: 5px; font-size: 20px">add_circle</mat-icon>
    Import Results
  </mat-label>
  <textarea
    id="notes"
    matInput
    micScrollBar
    type="text"
    rows="4"
    value="{{ this.translationService.translate(this.importResponse) }}"
    readonly
  ></textarea>
</mat-form-field>
